import React, { Component } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { roleRoutes, sectionRoutes, tabRoutes, notificationRoutes } from 'routes';
import { isSupervisorUser } from 'Auth/redux/auth.redux';

import TabHeader from './TabHeader';
import Sections from '../pages/Sections';
import Roles from '../pages/Roles';
import UsersRouting from '../pages/Users';
import GroupRouting from '../pages/Groups';
// import Tags from '../pages/Tags';
import Notifications from '../pages/Notifications';

import s from './style/Content.pcss';


@withRouter
@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
class Content extends Component {
  static propTypes = {
    isSupervisor: PropTypes.bool.isRequired,
  };

  render() {
    const { isSupervisor } = this.props;
    return (
      <div className={s.container}>
        <TabHeader />
        <div className={s.contentContainer}>
          <Switch>
            <Route path={sectionRoutes.section} component={Sections} />
            {!isSupervisor && <Route path={roleRoutes.role} component={Roles} />}
            <Route path={tabRoutes.users} component={UsersRouting} />
            <Route path={tabRoutes.groups} component={GroupRouting} />
            {/* !isSupervisor && <Route path={tabRoutes.tags} component={Tags} /> */}
            <Route path={notificationRoutes.section} component={Notifications} />
            <Redirect to={tabRoutes.sections} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/Root/Main/Content.js